import React, { useContext } from 'react';
import LanguageContext from '../../../Utiliz/LanguageContext';
import "./Header.css"
import Switch from 'react-switch'
import ukFlag from '../../../Assets/Images/language_uk.png';
import ToggleButton from '../../ToggleButton/ToggleButton';


const ToggleSwitch = () => {
  const { language, toggleLanguage } = useContext(LanguageContext);

  return (<>
    <div className="toglswr">
      <div>
        <ToggleButton />
      </div>
      <div className="toggle-switch-container">
        <label className="switch">
          <Switch
            className="swith-on-off"
            checked={language === 'en'}
            onChange={toggleLanguage}
            checkedIcon={
              <div className="switch-icon" style={{ backgroundImage: `url(${ukFlag})`, height: '20px', width: '50px', borderRadius: '50px' }} />
            }
          />
        </label>
      </div>
    </div>
  </>
  );
};

export default ToggleSwitch;
